import React, { FC} from "react";
import { StatisticsPage } from "../pages";
import { MuteButton } from "../components/atoms";

const StatisticsRoute: FC<{}> = () => {


    return (
        <React.Fragment>
            <StatisticsPage />
            <MuteButton />
        </React.Fragment>
    );
}

export default StatisticsRoute;